
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 41","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.987 40.499H9.886c-.077 0-.154.003-.23-.005-.41-.038-.695-.331-.692-.773.007-1.1-.01-2.199.015-3.299.023-.98.007-1.962.008-2.944.003-2.69-.01-5.38.014-8.07.026-2.88.01-5.76.023-8.638.004-.881.004-1.762.005-2.643 0-.238-.006-.245-.205-.146-1.286.64-2.57 1.283-3.856 1.925l-.867.433c-.447.225-.82.085-1.036-.398L.516 10.196l-.427-.96c-.194-.44-.067-.848.333-1.077l9.786-5.61c1.061-.608 2.121-1.22 3.183-1.828.8-.458 1.73-.137 2.117.747.434.993 1.051 1.81 1.914 2.403 1.763 1.213 4.131 1.008 5.698-.485.58-.554 1.022-1.215 1.362-1.96.229-.502.603-.805 1.114-.9.33-.063.647-.011.943.158 2.2 1.26 4.4 2.524 6.601 3.785l4.843 2.774c.533.306 1.067.61 1.6.918.392.227.52.635.33 1.065-.933 2.107-1.868 4.214-2.803 6.32-.069.155-.133.312-.206.464-.191.395-.575.54-.95.355-1.017-.504-2.033-1.012-3.05-1.519-.602-.3-1.205-.6-1.807-.904-.1-.05-.143-.056-.142.09a2107.421 2107.421 0 01.032 8.246c.002 1.727-.012 3.454.006 5.18.039 3.79.018 7.58.032 11.37.001.323.042.648.003.972-.052.417-.303.666-.693.696-.07.006-.142.003-.214.003H19.987z","fill":"#262626"}})])
          )
        }
      }
    